var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-module-list" },
    [
      _c("h3", { staticClass: "title" }, [
        _vm._v(_vm._s(_vm.$t("modules.modules"))),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "table-wrapper" },
        [
          _c("div", { staticClass: "toolbar" }, [
            _c(
              "div",
              { staticClass: "left" },
              [
                _c("a-input-search", {
                  staticClass: "row search-input",
                  staticStyle: { width: "300px" },
                  attrs: { placeholder: _vm.$t("message.startFilter") },
                  on: {
                    input: function ($event) {
                      return _vm.onSearch($event.target.value)
                    },
                  },
                  model: {
                    value: _vm.searchText,
                    callback: function ($$v) {
                      _vm.searchText = $$v
                    },
                    expression: "searchText",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "right" },
              [
                _c(
                  "SupsisButton",
                  {
                    attrs: { primary: "", ghost: "" },
                    on: { click: _vm.showCreateModuleModal },
                  },
                  [_vm._v(_vm._s(_vm.$t("modules.newModule")))]
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "a-spin",
            { attrs: { spinning: _vm.loading } },
            [
              _c("SupsisTable", {
                attrs: {
                  columns: _vm.getCols(),
                  rows: _vm.filteredModules(),
                  "top-pagination": true,
                  "empty-data-bordered": "",
                  "bottom-pagination": true,
                  "pagination-cursor": _vm.pagination,
                  options: {
                    rowStyleOption: _vm.rowStyleOption,
                    clipboardOption: _vm.clipboardOption,
                    fixedHeader: true,
                    id: "module-table",
                    borderX: true,
                    borderY: true,
                  },
                },
                on: {
                  "cursor-changed": function (cursor) {
                    return (_vm.pagination = cursor)
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.isCreateModuleModalVisible
        ? _c(
            "Modal2",
            {
              attrs: { xlarge: "" },
              on: { cancel: _vm.hideCreateModuleModal, ok: _vm.createModule },
              scopedSlots: _vm._u(
                [
                  {
                    key: "title",
                    fn: function () {
                      return [_vm._v(_vm._s(_vm.$t("modules.newModule")))]
                    },
                    proxy: true,
                  },
                ],
                null,
                false,
                1825740256
              ),
            },
            [
              _vm._v(" "),
              _c("CreateModuleForm", {
                ref: "createModuleForm",
                on: { success: _vm.onCreateModuleSuccess },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }